import React, {Component} from 'react';

class CloseIcon extends Component {
  render() {
    return (
        <svg className={this.props.className} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L8.99993 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9 1L1.00007 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
  }
}

export default CloseIcon;
